import { type Bucket } from 'investments/common/entities'

export function isCollateralBucket(bucket: Pick<Bucket, 'manager'>) {
  return bucket.manager?.slug === 'colateral'
}
